import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';

export type userConfirm = 'Confirm' | 'Denied';
export type detailsModal = {
  procedureName?: string;
  specialtyName?: string;
  activeProcedure?: boolean;
  inactiveProcedure?: boolean;
  deleteSpecialty?: boolean;
}

@Component({
  template: ` 
  <div class="content-container">
    <div class="text" >
        <p *ngIf="data.deleteSpecialty">Você deseja remover a especialidade <strong class="fontStrong">{{data.specialtyName}}</strong>
        <br /> 
        do procedimento <strong class="fontStrong">{{data.procedureName}}</strong> ?</p>
        <div *ngIf="data.inactiveProcedure">
          <p>Ao inativar o procedimento todas especialidades serão excluidas.</p>
          <br />
          <p>Você deseja inativar o procedimento <strong class="fontStrong">{{data.procedureName}}</strong> ?</p>
        </div>
        <p *ngIf="data.activeProcedure">Você deseja ativar o procedimento <strong class="fontStrong">{{data.procedureName}}</strong> ?</p>
        <br/>
        <br/>
    </div>

    <div class="actions-container">
        <button mat-button  class="btn-primary" (click)="onConfirm()" >
            Confirmar
        </button>

        <button mat-button (click)="onDeny()">
            Cancelar
        </button>
    </div>
  </div>
  `,
  styles: [`
    .fontStrong{
      font-size:18px;
    }
    `]
})

export class DeleteInactiveActiveModalComponent {
  private readonly userResponseSubject = new Subject<userConfirm>();
  readonly response$ = this.userResponseSubject.asObservable()

  constructor(
    public dialog: MatDialogRef<DeleteInactiveActiveModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: detailsModal
  ) { }

  onDeny() {
    this.userResponseSubject.next('Denied');
    this.dialog.close();
  }

  onConfirm() {
    this.userResponseSubject.next('Confirm');
    this.dialog.close()
  }
}
